import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import id from './locales/id/translation.json';
import tpi from './locales/tpi/translation.json';
import pt from './locales/pt/translation.json';
import fil from './locales/fil/translation.json';
import ar from './locales/ar/translation.json';

// All available translations - LOAD ALL OF THEM
const allTranslations = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  ar: { translation: ar },
  pt: { translation: pt },
  tpi: { translation: tpi },
  id: { translation: id },
  fil: { translation: fil },
};

// Get languages from localStorage for determining initial language only
const languagesFromStorage = localStorage.getItem('language')?.split(',') || [];
const defaultLanguageFromStorage = localStorage.getItem('is_language') || '';

// Filter out empty strings and trim whitespace
const languages = languagesFromStorage
  .map(lang => lang.trim())
  .filter(lang => lang && allTranslations[lang]);

const defaultLanguage = defaultLanguageFromStorage.trim();

console.log(languages, defaultLanguage, 'lan');

// Determine initial language but LOAD ALL RESOURCES
let initialLanguage = 'en';

if (languages.length > 0) {
  // Set initial language to default if it exists in the array, otherwise first available
  if (defaultLanguage && languages.includes(defaultLanguage)) {
    initialLanguage = defaultLanguage;
  } else if (languages.length > 0) {
    initialLanguage = languages[0];
  }
} else if (defaultLanguage && allTranslations[defaultLanguage]) {
  // If no languages array but default language exists, use default language
  initialLanguage = defaultLanguage;
} else {
  // Fallback to English
  initialLanguage = 'en';
}

console.log('All resources loaded:', Object.keys(allTranslations));
console.log('Initial language:', initialLanguage);

i18n
  .use(initReactI18next)
  .init({
    resources: allTranslations, // Load ALL translations
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    
    // Add these options for better language switching support
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    
    // Ensure language switching works properly
    load: 'languageOnly',
    preload: Object.keys(allTranslations), // Preload all languages
  });

// Listen for storage changes to update language dynamically
const handleStorageChange = (e) => {
  if (e.key === 'is_language' || e.type === 'cStorage') {
    const newDefaultLanguage = localStorage.getItem('is_language');
    if (newDefaultLanguage && newDefaultLanguage !== i18n.language) {
      i18n.changeLanguage(newDefaultLanguage);
    }
  }
};

// Add event listeners for storage changes
window.addEventListener('storage', handleStorageChange);
window.addEventListener('cStorage', handleStorageChange);

export default i18n;